/**
 * Demo / training accounts for the Toubanetwork demo application.
 * Password is the same for all listed users unless changed in the database.
 * Also documented in documentation/demo-application-users.md
 */
export const DEMO_TRAINING_PASSWORD = 'admin123';

/** @typedef {{ username: string, email?: string }} DemoAccount */

/**
 * @type {{ categoryKey: string, accounts: DemoAccount[] }[]}
 */
export const DEMO_TRAINING_SECTIONS = [
  {
    categoryKey: 'login.demoCatAdmin',
    accounts: [{ username: 'admin' }],
  },
  {
    categoryKey: 'login.demoCatChefZone',
    accounts: [
      { username: 'andiaye', email: 'manager@toubanetwork.com' },
      { username: 'ndongoel', email: 'ndongo@toubanetwork.com' },
      { username: 'cdiop' },
      { username: 'mportdakar', email: 'mportdakar@toubanetwork.com' },
    ],
  },
  {
    categoryKey: 'login.demoCatPeseur',
    accounts: [
      { username: 'nbirame', email: 'nbirame@toubanetwork.com' },
      { username: 'mbaye', email: 'mbaye@toubanetwork.com' },
    ],
  },
  {
    categoryKey: 'login.demoCatClient',
    accounts: [
      { username: 'fatima@logistics.sn', email: 'operator@toubanetwork.com' },
      { username: 'aborid', email: 'operator@toubanetwork.com' },
      { username: 'adiallo', email: 'malaydiaw@toubanetwork.con' },
      { username: 'moussaba', email: 'moussa@trader.sn' },
    ],
  },
  {
    categoryKey: 'login.demoCatDriver',
    accounts: [{ username: 'ousemane' }],
  },
  {
    categoryKey: 'login.demoCatAccountant',
    accounts: [{ username: 'fasamb' }],
  },
  {
    categoryKey: 'login.demoCatSuper',
    accounts: [{ username: 'super' }],
  },
];
